import { render, staticRenderFns } from "./FormSect.vue?vue&type=template&id=1a7226c8&functional=true&"
import script from "./FormSect.vue?vue&type=script&lang=js&"
export * from "./FormSect.vue?vue&type=script&lang=js&"
import style0 from "./FormSect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports